//@flow
export const agendaConstants = {
  CHANGE_MEDICO: "CHANGE_MEDICO",
  RECEIVE_DATA: "RECEIVE_DATA",
  CLEAR_MEDICO: "CLEAR_MEDICO",
  SHOW_DIV_MEDICO: "SHOW_DIV_MEDICO"
};
